import { rootApi } from 'root-api-graphql'

const StartAIEnrichmentEmailMutation = `
  mutation StartAIEnrichmentEmail {
    startAIEnrichmentEmail
  }
`

const GetContactsSettingsQuery = `
  query GetContactsSettings {
    getContactsSettings {
      calendlyBookingEnabled
      notetakerEnabled
      gmailEnabled
      blockedEmails
      blockedDomains
    }
  }
`

const GetGoogleFormsImportContextQuery = `
  query GetGoogleFormsImportContext {
    googleFormsImportContext {
      isConnected
      forms {
        id
        title
        isAlreadyConnected
      }
    }
  }
`

const DisconnectGoogleFormsAccountMutation = `
  mutation DisconnectGoogleFormsAccount($input: ProviderAccountDeleteType!) {
    disconnectGoogleFormsAccount(input: $input)
  }
`

const UpsertContactsSettingsMutation = `
  mutation UpsertContactsSettings($input: ContactsSettingsInput!) {
    upsertContactsSettings(input: $input) {
      calendlyBookingEnabled
      notetakerEnabled
      gmailEnabled
      blockedEmails
      blockedDomains
    }
  }
`

const getBaseUrl = () => {
  const value = typeof window !== 'undefined' && window.OAP_API_GRAPHQL_BASE
  return (value && String(value)) || '/api/oap-api/graphql'
}

const api = rootApi.enhanceEndpoints({ addTagTypes: ['ContactsSettings', 'GoogleFormsImportContext'] }).injectEndpoints({
  endpoints: (build) => ({
    startAIEnrichmentEmail: build.mutation({
      query: () => ({
        document: StartAIEnrichmentEmailMutation,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true },
      }),
    }),
    getContactsSettings: build.query({
      query: () => ({
        document: GetContactsSettingsQuery,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
      providesTags: ['ContactsSettings'],
    }),
    getGoogleFormsImportContext: build.query({
      query: () => ({
        document: GetGoogleFormsImportContextQuery,
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
      providesTags: ['GoogleFormsImportContext'],
    }),
    disconnectGoogleFormsAccount: build.mutation({
      query: (input) => ({
        document: DisconnectGoogleFormsAccountMutation,
        variables: { input },
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
    }),
    upsertContactsSettings: build.mutation({
      query: (input) => ({
        document: UpsertContactsSettingsMutation,
        variables: { input },
        meta: { baseUrl: getBaseUrl(), fetchAuthToken: true, treatGraphqlErrorsAsFailure: true },
      }),
    }),
  })
})

export const {
  useDisconnectGoogleFormsAccountMutation,
  useStartAIEnrichmentEmailMutation,
  useGetContactsSettingsQuery,
  useGetGoogleFormsImportContextQuery,
  useUpsertContactsSettingsMutation,
} = api

export const updateCachedContactsSettings = (updater) => api.util.updateQueryData('getContactsSettings', undefined, updater)
export const updateCachedGoogleFormsImportContext = (updater) => (
  api.util.updateQueryData('getGoogleFormsImportContext', undefined, updater)
)
